import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_CODE8OCCURRENCES_REQUEST,
  FETCH_CODE8OCCURRENCES_SUCCESS,
  FETCH_CODE8OCCURRENCES_ERROR,
  FETCH_CODE8OCCURRENCES_REQUEST_V2,
  FETCH_CODE8OCCURRENCES_SUCCESS_V2,
  FETCH_CODE8OCCURRENCES_ERROR_V2,
} from 'actionTypes'

/*
 * REQUEST CODE 8 OCCURRENCES
 */
export const fetchCode8Occurrences = (auth, filters) => (dispatch) => {
  dispatch(fetchCode8OccurrencesRequest())

  if (!filters || !filters.idBranch) {
    filters = {
      ...filters,
      idBranch: auth.user.locationCode.padStart(4, '0'),
    }
  }

  const params = {
    ...filters,
  }

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.CODE8OCCURRENCES, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchCode8OccurrencesSuccess(response.data, params))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchCode8OccurrencesError(error, params))
      dispatch(hideSpinner())
    })
}

export const fetchCode8OccurrencesRequest = () => ({
  type: FETCH_CODE8OCCURRENCES_REQUEST,
})

export const fetchCode8OccurrencesSuccess = (data, filters) => ({
  type: FETCH_CODE8OCCURRENCES_SUCCESS,
  payload: data,
  filters,
})

export const fetchCode8OccurrencesError = (error, filters) => ({
  type: FETCH_CODE8OCCURRENCES_ERROR,
  payload: error,
  filters,
})

export const fetchCode8OccurrencesV2 = (dsToken, filters, signalController = false) => (dispatch) => {
  dispatch(fetchCode8OccurrencesRequestV2())
  
  const params = {
    ...filters,
  }

  const onClose = () => dispatch(hideSpinner())
  const onError = (error) => {
     
    dispatch(fetchCode8OccurrencesErrorV2(error, params))
    dispatch(hideSpinner())
  }

  const abort  = () => {
    signalController.abort()
    onClose()
  }

  const onMessage = (response) => {
    dispatch(fetchCode8OccurrencesSuccessV2(response.data, params))
    dispatch(hideSpinner())
  }

  dispatch(showSpinner("", true, abort))
  return new Api(dsToken, dispatch)
    .eventSourceStream(API_URL.CODE80OCURRENCES_V2, params, null, signalController, onMessage, onClose, onError)
    .catch((error) => {
  
      dispatch(fetchCode8OccurrencesErrorV2(error, params))
      dispatch(hideSpinner())
    })

}
 
export const fetchCode8OccurrencesRequestV2 = () => ({
  type: FETCH_CODE8OCCURRENCES_REQUEST_V2,
})

export const fetchCode8OccurrencesSuccessV2 = (data, filters) => ({
  type: FETCH_CODE8OCCURRENCES_SUCCESS_V2,
  payload: data,
  filters,
})

export const fetchCode8OccurrencesErrorV2 = (error, filters) => ({
  type: FETCH_CODE8OCCURRENCES_ERROR_V2,
  payload: error,
  filters,
})